module.exports = __webpack_public_path__ + "static/img/thunderbay3.a34bd71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/thunderbay3.jpg
// module id = 140
// module chunks = 9